module.exports = __webpack_public_path__ + "media/images/registration-502a6f0c40416938fd4325c3a1fe2e5c.jpg";